import React, { KeyboardEvent } from 'react';

import { Box, Typography } from '@material-ui/core';

import { INVITE_CONTACTS_LIMIT } from '@vyce/core/src/api/types';

import { BulkPhoneEntryApi } from '../types';
import { PhoneOrEmail } from './PhoneOrEmail';

interface Props {
  phones: string[];
  addPhoneToList: () => void;
  handlePhoneFieldKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
  deleteContact: (phone: string) => void;
  disabled: boolean;
  bulkPaste: BulkPhoneEntryApi;
}

export const NewUsersPanel: React.FC<Props> = ({
  phones,
  addPhoneToList,
  handlePhoneFieldKeyDown,
  deleteContact,
  disabled,
  bulkPaste,
}) => (
  <Box>
    <Typography variant="body2" color="textSecondary">
      Not on Vyce yet? Add their mobile number — or paste a whole list — and we'll text them an
      invite to join.
    </Typography>

    <PhoneOrEmail
      phoneOnly
      disabled={disabled}
      phones={phones}
      addPhoneToList={addPhoneToList}
      handlePhoneFieldKeyDown={handlePhoneFieldKeyDown}
      deleteContact={deleteContact}
      bulkPaste={bulkPaste}
      bulkLimitHint={`you can add up to ${INVITE_CONTACTS_LIMIT} per invite`}
    />
  </Box>
);
